const PUBLIC_IPFS_GATEWAY = "https://gateway.pinata.cloud/ipfs/";

export function publicMediaUrl(uri: string): string | null {
  const value = uri.trim();
  if (!value) return null;

  if (value.startsWith("ipfs://")) {
    const cid = value.slice(7);
    return /^[a-zA-Z0-9]+$/.test(cid) ? `${PUBLIC_IPFS_GATEWAY}${cid}` : null;
  }

  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
}
